// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SpinnerTsx from "./Spinner.tsx";

let make = SpinnerTsx.Spinner;

export {
  make,
}
/* make Not a pure module */
